(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-video-strip"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.customer-video-strip__button');
    if (!button) return;

    const video = button.querySelector('video');
    if (!video) return;

    event.preventDefault();

    document.querySelectorAll('.customer-video-strip__button[data-playing="true"]').forEach((activeButton) => {
      if (activeButton === button) return;
      const activeVideo = activeButton.querySelector('video');
      if (activeVideo) activeVideo.pause();
      activeButton.dataset.playing = 'false';
    });

    const setPlaying = (isPlaying) => {
      button.dataset.playing = isPlaying ? 'true' : 'false';
    };

    video.addEventListener('play', () => setPlaying(true), { once: true });
    video.addEventListener('pause', () => setPlaying(false), { once: true });
    video.addEventListener('ended', () => setPlaying(false), { once: true });

    if (video.paused) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.then(() => setPlaying(true)).catch(() => setPlaying(false));
      } else {
        setPlaying(true);
      }
    } else {
      video.pause();
      setPlaying(false);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
